module.exports = __webpack_public_path__ + "static/media/blank-template.149e2ed7.png";